if (window.innerWidth < 1025) {
  document.addEventListener("scroll", (event) => {
    let header_mb_height = document.querySelector(".header-mobile").clientHeight;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > header_mb_height ) {
      document.querySelector(".header-mobile").classList.add("has-sticky");
    } else {
      document.querySelector(".header-mobile").classList.remove("has-sticky");
    }

    let main_top = document.querySelector(".main-content").getBoundingClientRect().top.toFixed();
    let searh_mb_height = document.querySelector(".search_mb").clientHeight;
    let minus =  main_top - searh_mb_height ;
    
     if (minus < 0 ) {
      document.querySelector(".search_mb").classList.add("has-sticky");
    } else {
      document.querySelector(".search_mb").classList.remove("has-sticky");
    }
  });
}


document.getElementById("previousPageButton").addEventListener("click", function() {
    window.history.back();
});
